export default function HelpIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10Z'
        fill='#EBF2F2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.57059 7.32143C8.57059 6.53246 9.21019 5.89286 9.99916 5.89286C10.7881 5.89286 11.4277 6.53246 11.4277 7.32143C11.4277 8.1104 10.7881 8.75 9.99916 8.75C9.40743 8.75 8.92773 9.2297 8.92773 9.82143V10.8929C8.92773 11.4846 9.40743 11.9643 9.99916 11.9643C10.5909 11.9643 11.0706 11.4846 11.0706 10.8929V10.7294C12.5196 10.2743 13.5706 8.92059 13.5706 7.32143C13.5706 5.34899 11.9716 3.75 9.99916 3.75C8.02672 3.75 6.42773 5.34899 6.42773 7.32143C6.42773 7.91316 6.90743 8.39286 7.49916 8.39286C8.09089 8.39286 8.57059 7.91316 8.57059 7.32143ZM11.4277 14.8214C11.4277 14.0325 10.7881 13.3929 9.99916 13.3929C9.21019 13.3929 8.57059 14.0325 8.57059 14.8214C8.57059 15.6104 9.21019 16.25 9.99916 16.25C10.7881 16.25 11.4277 15.6104 11.4277 14.8214Z'
        fill='#8E9393'
      />
    </svg>
  )
}
